module.exports = __webpack_public_path__ + "static/media/sign-in-background-2.a3a56812.png";